export default __webpack_public_path__ + "static/media/nucleo.6dfb4833.woff2";